import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { UntypedFormArray, UntypedFormBuilder } from "@angular/forms";
import {
	addReminderNote,
	ETS1_MAX_REMINDER_NOTES,
	ETS1_REMINDER_NOTE_MAX_LENGTH,
	removeReminderNote,
} from "src/app/cbta-web/ets1/reminder-notes/ets1-reminder-notes-form.utils";

@Component({
	selector: "app-ets1-reminder-notes-config",
	templateUrl: "./ets1-reminder-notes-config.component.html",
	styleUrls: ["./ets1-reminder-notes-config.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class Ets1ReminderNotesConfigComponent {
	@Input({ required: true }) reminderNotes!: UntypedFormArray;
	@Input() readOnly = false;

	readonly maxNotes = ETS1_MAX_REMINDER_NOTES;
	readonly maxLength = ETS1_REMINDER_NOTE_MAX_LENGTH;

	get noteCount(): number {
		return this.reminderNotes?.length ?? 0;
	}

	get canAdd(): boolean {
		return this.noteCount < this.maxNotes;
	}

	constructor(private readonly fb: UntypedFormBuilder) {}

	onAdd(): void {
		if (this.readOnly) return;
		addReminderNote(this.reminderNotes, this.fb);
	}

	onRemove(index: number): void {
		if (this.readOnly) return;
		removeReminderNote(this.reminderNotes, index);
	}
}
